/**
 * lib/views/javascripts/proto-plugins.js — the entry module for the Plugins
 * window (lib/views/htmls/proto/plugins.ejs; ADR 0082 D3).
 *
 * Its config — the agent's name, the bots, the host's tray route and the
 * category words — arrives as boot data (#m33-plugins-boot). The window sits
 * outside the centre panel, so it mounts once per page.
 *
 * Contents: view
 * Ontology: Code object M33C-1105 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

import { readBootData } from './shared/boot-data.js';
import { mountPlugins } from './proto/plugins/plugins.js';

// ── Start ────────────────────────────────────────────────────────────────
mountPlugins(readBootData(document, 'm33-plugins-boot'));
